module.exports = __webpack_public_path__ + "static/logo-45caba4b1e66f2c93d2e2f7d29dc2f79.png";